import {
  HEX_0C1017,
  HEX_18232F,
  HEX_1D2939,
  HEX_212F41,
  HEX_646A7E,
  HEX_9BA4B6,
  HEX_CED7E2,
  HEX_E2E5EB,
  HEX_E2E8F0,
  HEX_F2F6FA,
  HEX_FCFDFE,
} from '@tanium/colors';
import { defineColor, Link } from '@tanium/react-theme-definition';

export const HeaderFill = defineColor([HEX_CED7E2, HEX_0C1017]);
export const HeaderBottomBorder = defineColor([HEX_F2F6FA, HEX_1D2939]);

export const Fill = defineColor([HEX_E2E8F0, HEX_18232F]);

export const ShowFiltersToggle = Link;

export const FilterLabelText = defineColor([HEX_646A7E, HEX_E2E5EB]);

export const UnavailableFill = defineColor([HEX_FCFDFE, HEX_212F41]);
export const UnavailableForeground = defineColor([HEX_646A7E, HEX_9BA4B6]);
